import { render, staticRenderFns } from "./app-real.vue?vue&type=template&id=40d3fc34&scoped=true"
import script from "./app-real.vue?vue&type=script&lang=js"
export * from "./app-real.vue?vue&type=script&lang=js"
import style0 from "./app-real.vue?vue&type=style&index=0&id=40d3fc34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d3fc34",
  null
  
)

export default component.exports